import { jsx as _jsx } from "react/jsx-runtime";
import { Table, Typography } from 'antd';
const { Link } = Typography;
const RelatedSpecificationsTable = ({ data }) => {
    const columns = [
        {
            title: 'Certificate Name',
            dataIndex: ['objRegulatorySummary', 'strServiceName'],
            key: 'strServiceName'
        },
        {
            title: 'Regulatory Name',
            key: 'strRegulatorName',
            render: (text, record) => {
                var _a, _b;
                const regulatorName = (_a = record === null || record === void 0 ? void 0 : record.objRegulatorySummary) === null || _a === void 0 ? void 0 : _a.strRegulatorName;
                let encodedId = (record === null || record === void 0 ? void 0 : record.strRegSummaryId) ? btoa((record === null || record === void 0 ? void 0 : record.strRegSummaryId) + '-' + ((_b = record === null || record === void 0 ? void 0 : record.objRegulatorySummary) === null || _b === void 0 ? void 0 : _b.intVersion)) : null;
                const url = `/regulation-information/details/${encodedId}`;
                return (_jsx(Link, { href: url, target: "_blank", children: regulatorName }));
            }
        },
        {
            title: 'Product Category',
            key: 'productCategory',
            render: (text, record) => {
                var _a, _b, _c, _d, _e;
                const isSpecificAll = ((_a = record === null || record === void 0 ? void 0 : record.objRegulatorySummary) === null || _a === void 0 ? void 0 : _a.intProdSubSegSpecificAll) === 1;
                const productMain = (_c = (_b = record === null || record === void 0 ? void 0 : record.objRegulatorySummary) === null || _b === void 0 ? void 0 : _b.objLuProductMainType) === null || _c === void 0 ? void 0 : _c.strLongDesc;
                const productType = (_e = (_d = record === null || record === void 0 ? void 0 : record.objRegulatorySummary) === null || _d === void 0 ? void 0 : _d.objLuProductType) === null || _e === void 0 ? void 0 : _e.strLongDesc;
                return isSpecificAll ? 'All' : `${productMain} (${productType})`;
            }
        },
        {
            title: 'Service',
            dataIndex: ['objRegulatorySummary', 'objLuServiceCode', 'strLongDesc'],
            key: 'strLongDesc'
        },
        {
            title: 'Related Certificate',
            key: 'relatedCertificate',
            render: (text, record) => {
                if (record.objRegulatorySummary) {
                    const { boolBomLinked, strEncodeSumRegId } = record.objRegulatorySummary;
                    let encodedId = (record === null || record === void 0 ? void 0 : record.strRegSummaryId) ? btoa(record === null || record === void 0 ? void 0 : record.strRegSummaryId) : null;
                    const certUrl = `/certificates?show-link=${encodedId}`;
                    return boolBomLinked ? (_jsx(Link, { href: certUrl, target: "_blank", children: "View" })) : ('Not Applicable');
                }
                return 'Not Applicable';
            }
        }
    ];
    return _jsx(Table, { columns: columns, dataSource: data, style: { width: '100%' }, size: 'small', scroll: { x: 550 } });
};
export default RelatedSpecificationsTable;
